export const API_KEY = 'AIzaSyBwJt3TSfMM-U7Zx2y79kjIkB-bT3jOWHA';

export default API_KEY;